export const APP_PERMISSIONS = [
  'active_assortment_view',
  'assortment_banners_edit',
  'assortment_banners_view',
  'assortment_backups_create',
  'assortment_backups_restore',
  'assortment_banners_publish',
  'assortment_launches_create',
  'assortment_launches_edit',
  'assortment_launches_publish',
  'assortment_launches_view',
  'assortment_materials_clean_up',
  'assortment_materials_replace',
  'assortment_materials_sequences_edit',
  'assortment_materials_sync',
  'audit_trails_view',
  'sox_compliance_scheduled_reports_create',
  'sox_compliance_scheduled_reports_delete',
  'sox_compliance_scheduled_reports_edit',
  'sox_compliance_view',
  'customers_banners_view',
  'customers_stores_view',
  'invites_delete',
  'invites_send',
  'invites_view',
  'map_viewAllAreas',
  'materials_bcp_priced_view',
  'materials_materials_list_view',
  'materials_price_list_view',
  'operations_execute',
  'orders_all_view',
  'orders_charts_view',
  'orders_editQuantities',
  'orders_flagged_view',
  'orders_leg_release_timeout_edit',
  'orders_payment_review_release',
  'orders_payment_review_view',
  'orders_release',
  'orders_returns_view',
  'orders_uncouple',
  'reports_view',
  'reports_view_ecc',
  'reports_view_material',
  'reports_view_misc',
  'reports_view_operations',
  'reports_view_order_service',
  'reports_view_salesforce',
  'roles_view',
  'upload_autoDistro',
  'upload_autoInject',
  'upload_autoInjectDeliveryDates',
  'upload_autoInjectRMA',
  'upload_ediPOConfControl',
  'upload_onHandInventoryPartial',
  'upload_onHandInventoryUOM',
  'upload_onHandInventoryDuns',
  'upload_materialSpecificationConversion',
  'upload_merchandise',
  'upload_myUpload_view',
  'upload_allUploads_view',
  'upload_nodAddPosition',
  'upload_erpSkuSubstitution',
  'upload_limitQuantity',
  'upload_limitQuantityExemptions',
  'upload_routeStopSequence',
  'upload_skuUpcOverride',
  'upload_suspendOrderSubmission',
  'upload_taxRate',
  'users_manageAdmins',
  'users_managePermissionsOverrides',
  'users_manageAccess',
  'users_manageTerritoriesOverrides',
  'users_view',
] as const

export const CRT_PERMISSIONS = [
  'crt_async_exports_view',
  'crt_audit_trails_view',
  'crt_azure_imports_view',
  'crt_azure_imports_delete',
  'crt_azure_imports_manage',
  'crt_brand_variants_view',
  'crt_channel_mix_create',
  'crt_channel_mix_delete',
  'crt_channel_mix_edit',
  'crt_channel_mix_view',
  'crt_unreleased_materials_edit',
  'crt_unreleased_materials_view',
  'crt_product_type_variant_create',
  'crt_product_type_variant_view',
  'crt_product_types_edit',
  'crt_product_types_view',
  'crt_material_group_overrides_edit',
  'crt_material_group_overrides_view',
  'crt_agreement_mappings_edit',
  'crt_agreement_mappings_view',
  'crt_agreements_create',
  'crt_agreements_view',
  'crt_sales_deal_actuals_create',
  'crt_sales_deal_actuals_delete',
  'crt_sales_deal_actuals_edit',
  'crt_sales_deal_actuals_export',
  'crt_sales_deal_actuals_view',
  'crt_federal_excise_edit',
  'crt_federal_excise_view',
  'crt_invites_delete',
  'crt_invites_send',
  'crt_invites_view',
  'crt_key_account_contract_estimates_delete',
  'crt_key_account_contract_estimates_edit',
  'crt_key_account_contract_estimates_view',
  'crt_key_accounts_view',
  'crt_materials_materials_list_view',
  'crt_materials_price_list_view',
  'crt_retailer_margins_fmc_edit',
  'crt_retailer_margins_fmc_view',
  'crt_retailer_margins_nc_edit',
  'crt_retailer_margins_nc_view',
  'crt_wholesaler_margins_fmc_edit',
  'crt_wholesaler_margins_fmc_view',
  'crt_wholesaler_margins_nc_edit',
  'crt_wholesaler_margins_nc_view',
  'crt_retailer_rates_edit',
  'crt_retailer_rates_view',
  'crt_consumer_rates_edit',
  'crt_consumer_rates_view',
  'crt_currency_rates_manage',
  'crt_commercial_partners_view',
  'crt_cost_of_goods_create',
  'crt_cost_of_goods_delete',
  'crt_cost_of_goods_edit',
  'crt_cost_of_goods_view',
  'crt_versions_approve',
  'crt_versions_create',
  'crt_versions_delete',
  'crt_versions_edit',
  'crt_versions_view',
  'crt_lmc_targets_edit',
  'crt_lmc_targets_view',
  'crt_budget_allocations_create',
  'crt_budget_allocations_delete',
  'crt_budget_allocations_edit',
  'crt_budget_allocations_view',
  'crt_budget_estimates_edit',
  'crt_budget_tracker_view',
  'crt_calculation_run_accruals_create',
  'crt_calculation_run_accruals_delete',
  'crt_calculation_run_accruals_edit',
  'crt_calculation_run_accruals_view',
  'crt_ip_accruals_create',
  'crt_ip_accruals_delete',
  'crt_ip_accruals_edit',
  'crt_ip_accruals_export',
  'crt_ip_accruals_view',
  'crt_rap_forecasts_create',
  'crt_rap_forecasts_delete',
  'crt_rap_forecasts_edit',
  'crt_rap_forecasts_view',
  'crt_distribution_margin_mix_create',
  'crt_distribution_margin_mix_delete',
  'crt_distribution_margin_mix_edit',
  'crt_distribution_margin_mix_view',
  'crt_distribution_banner_mix_edit',
  'crt_distribution_banner_mix_view',
  'crt_bpc_actuals_view',
  'crt_bpc_actuals_create',
  'crt_bpc_actuals_edit',
  'crt_bpc_actuals_delete',
  'crt_notifications_manage',
  'crt_notifications_view',
  'crt_volume_forecasts_view',
  'crt_volume_forecasts_configure',
  'crt_volume_scenarios_view',
  'crt_volume_scenarios_create',
  'crt_volume_scenarios_edit',
  'crt_volume_scenarios_delete',
  'crt_investments_view',
  'crt_manual_investments_create',
  'crt_manual_investments_delete',
  'crt_manual_investments_edit',
  'crt_manual_investments_view',
  'crt_pe_pricing_assumptions_create',
  'crt_pe_pricing_assumptions_delete',
  'crt_pe_pricing_assumptions_edit',
  'crt_pe_pricing_assumptions_view',
  'crt_pe_pricing_rate_table_view',
  'crt_pe_tax_assumptions_create',
  'crt_pe_tax_assumptions_delete',
  'crt_pe_tax_assumptions_edit',
  'crt_pe_tax_assumptions_view',
  'crt_pnl_actuals_view',
  'crt_pnl_forecasts_view',
  'crt_price_list_snapshots_refresh',
  'crt_variance_analysis_view',
  'crt_roles_view',
  'crt_upload_myUpload_view',
  'crt_upload_allUploads_view',
  'crt_users_manageAccess',
  'crt_users_view',
] as const

export const CREDIT_PERMISSIONS = [
  'credit_audit_trails_view',
  'credit_customers_view',
  'credit_duns_and_bradstreet_edit',
  'credit_index_scores_create',
  'credit_index_scores_delete',
  'credit_index_scores_update',
  'credit_index_scores_view',
  'google_financial_statements_create',
  'google_financial_statements_delete',
  'google_financial_statements_update',
  'google_financial_statements_view',
  'credit_invites_delete',
  'credit_invites_send',
  'credit_invites_view',
  'credit_delegation_of_authority_view',
  'credit_delegation_of_authority_edit',
  'credit_limit_reviews_view',
  'credit_blocked_orders_view',
  'credit_initiatives_view',
  'credit_operations_view',
  'credit_multiplier_view',
  'credit_multiplier_edit',
  'credit_order_cutoff_view',
  'credit_order_cutoff_edit',
  'credit_province_aov_view',
  'credit_province_aov_edit',
  'credit_very_low_risk_customers_create',
  'credit_very_low_risk_customers_delete',
  'credit_very_low_risk_customers_view',
  'credit_review_events_view',
  'credit_roles_view',
  'credit_sap_imports_create',
  'credit_sap_imports_delete',
  'credit_upload_myUpload_view',
  'credit_upload_allUploads_view',
  'credit_users_manageAccess',
  'credit_users_view',
] as const

export const PERMISSIONS = [...APP_PERMISSIONS, ...CRT_PERMISSIONS, ...CREDIT_PERMISSIONS] as const

export type UserPermission = (typeof PERMISSIONS)[number]

/**
 * Permissions that only mean anything on a Nova environment. The handlers that enforce them exist
 * everywhere, because the module is mounted unconditionally, but nothing on a mainline deployment
 * ever reaches them.
 *
 * They stay out of what mainline deployments seed and report on, so they neither reach the database
 * nor appear as rows in the SOX permissions report where they would describe capabilities no
 * mainline user has. Filter with `withoutNovaOnly` at each of those surfaces; the permission itself
 * remains in `PERMISSIONS` so the handlers type-check on every build.
 */
export const NOVA_ONLY_PERMISSIONS = [
  'orders_leg_release_timeout_edit',
  'orders_payment_review_release',
  'orders_payment_review_view',
  'orders_uncouple',
] as const satisfies readonly UserPermission[]

export type NovaOnlyPermission = (typeof NOVA_ONLY_PERMISSIONS)[number]

const NOVA_ONLY_PERMISSION_SET: ReadonlySet<string> = new Set(NOVA_ONLY_PERMISSIONS)

export function isNovaOnlyPermission(permission: string): permission is NovaOnlyPermission {
  return NOVA_ONLY_PERMISSION_SET.has(permission)
}

/** The given permissions, minus the Nova-only ones when this is not a Nova environment. */
export function withoutNovaOnly<T extends string>(permissions: readonly T[], isNova: boolean): T[] {
  return isNova ? [...permissions] : permissions.filter((p) => !isNovaOnlyPermission(p))
}
export type UserPermissions = Record<UserPermission, boolean>

export type AppPermission = (typeof APP_PERMISSIONS)[number]
export type CrtPermission = (typeof CRT_PERMISSIONS)[number]
export type CreditPermission = (typeof CREDIT_PERMISSIONS)[number]

export type AppRolePermissions = Record<AppPermission, boolean>
export type CrtRolePermissions = Record<CrtPermission, boolean>
export type CreditRolePermissions = Record<CreditPermission, boolean>

export const PERMISSION_DESCRIPTIONS: Record<UserPermission, string> = {
  active_assortment_view: 'View the active assortment',
  assortment_banners_edit: 'Edit banner assortment configurations',
  assortment_banners_view: 'View banner assortment configurations',
  assortment_backups_create: 'Create assortment backups',
  assortment_backups_restore: 'Restore assortment from backups',
  assortment_banners_publish: 'Publish banner assortment changes',
  assortment_launches_create: 'Create new assortment launches',
  assortment_launches_edit: 'Edit assortment launches',
  assortment_launches_publish: 'Publish assortment launches',
  assortment_launches_view: 'View assortment launches',
  assortment_materials_clean_up: 'Clean up assortment materials',
  assortment_materials_replace: 'Replace assortment materials',
  assortment_materials_sequences_edit: 'Edit material sequences in assortment',
  assortment_materials_sync: 'Synchronize assortment materials',
  audit_trails_view: 'View audit trails and activity logs',
  crt_async_exports_view: 'View the CRT async exports queue (My Exports)',
  crt_audit_trails_view: 'View CRT audit trails and activity logs',
  crt_azure_imports_delete: 'Delete CRT automated imports',
  crt_azure_imports_manage: 'Configure CRT automated imports',
  crt_azure_imports_view: 'View CRT automated imports',
  crt_brand_variants_view: 'View CRT brand variants',
  crt_channel_mix_create: 'Create channel mix',
  crt_channel_mix_delete: 'Delete channel mix',
  crt_channel_mix_edit: 'Edit channel mix',
  crt_channel_mix_view: 'View channel mix',
  crt_unreleased_materials_edit: 'Edit unreleased materials',
  crt_unreleased_materials_view: 'View unreleased materials',
  crt_product_type_variant_create: 'Create product type variant',
  crt_product_type_variant_view: 'View product type variant',
  crt_product_types_edit: 'Edit product type mappings',
  crt_product_types_view: 'View product type mappings',
  crt_material_group_overrides_edit: 'Edit material group overrides',
  crt_material_group_overrides_view: 'View material group overrides',
  crt_agreement_mappings_edit: 'Edit master agreement mappings',
  crt_agreement_mappings_view: 'View master agreement mappings',
  crt_agreements_create: 'Create agreements',
  crt_agreements_view: 'View agreements',
  crt_sales_deal_actuals_create: 'Create sales deal actuals',
  crt_sales_deal_actuals_delete: 'Delete sales deal actuals',
  crt_sales_deal_actuals_edit: 'Edit sales deal actuals',
  crt_sales_deal_actuals_export: 'Export sales deal actuals (details and raw CSV)',
  crt_sales_deal_actuals_view: 'View sales deal actuals',
  crt_federal_excise_edit: 'Edit federal excise mappings',
  crt_federal_excise_view: 'View federal excise mappings',
  crt_invites_delete: 'Delete CRT user invitations',
  crt_invites_send: 'Send CRT user invitations',
  crt_invites_view: 'View CRT user invitations',
  crt_key_account_contract_estimates_delete: 'Delete key account contract estimates',
  crt_key_account_contract_estimates_edit: 'Edit key account contract estimates',
  crt_key_account_contract_estimates_view: 'View key account contract estimates',
  crt_key_accounts_view: 'View the key accounts roll-up',
  crt_materials_materials_list_view: 'View the CRT materials list',
  crt_materials_price_list_view: 'View the CRT price list',
  crt_retailer_margins_fmc_edit: 'Edit FMC retailer margins',
  crt_retailer_margins_fmc_view: 'View FMC retailer margins',
  crt_retailer_margins_nc_edit: 'Edit NC retailer margins',
  crt_retailer_margins_nc_view: 'View NC retailer margins',
  crt_wholesaler_margins_fmc_edit: 'Edit FMC wholesaler margins',
  crt_wholesaler_margins_fmc_view: 'View FMC wholesaler margins',
  crt_wholesaler_margins_nc_edit: 'Edit NC wholesaler margins',
  crt_wholesaler_margins_nc_view: 'View NC wholesaler margins',
  crt_retailer_rates_edit: 'Edit retailer rates',
  crt_retailer_rates_view: 'View retailer rates',
  crt_consumer_rates_edit: 'Edit consumer rates',
  crt_consumer_rates_view: 'View consumer rates',
  crt_currency_rates_manage: 'Manage currency rates',
  crt_commercial_partners_view: 'View commercial partners',
  crt_cost_of_goods_create: 'Create cost of goods',
  crt_cost_of_goods_delete: 'Delete cost of goods',
  crt_cost_of_goods_edit: 'Edit cost of goods',
  crt_cost_of_goods_view: 'View cost of goods',
  crt_versions_approve: 'Approve CRT versions (BPC Submitted)',
  crt_versions_create: 'Create CRT versions',
  crt_versions_delete: 'Delete CRT versions',
  crt_versions_edit: 'Edit CRT versions',
  crt_versions_view: 'View CRT versions',
  crt_lmc_targets_edit: 'Edit last minute commitment targets',
  crt_lmc_targets_view: 'View last minute commitment targets',
  crt_budget_allocations_create: 'Create budget allocations',
  crt_budget_allocations_delete: 'Delete budget allocations',
  crt_budget_allocations_edit: 'Edit budget allocations',
  crt_budget_allocations_view: 'View budget allocations',
  crt_budget_estimates_edit: 'Edit budget tracker estimates',
  crt_budget_tracker_view: 'View the budget tracker',
  crt_calculation_run_accruals_create: 'Create calculation run accruals',
  crt_calculation_run_accruals_delete: 'Delete calculation run accruals',
  crt_calculation_run_accruals_edit: 'Edit calculation run accruals',
  crt_calculation_run_accruals_view: 'View calculation run accruals',
  crt_ip_accruals_create: 'Create IP accruals',
  crt_ip_accruals_delete: 'Delete IP accruals',
  crt_ip_accruals_edit: 'Edit IP accruals',
  crt_ip_accruals_export: 'Export IP accruals (details and raw CSV)',
  crt_ip_accruals_view: 'View IP accruals',
  crt_rap_forecasts_create: 'Create RAP forecasts',
  crt_rap_forecasts_delete: 'Delete RAP forecasts',
  crt_rap_forecasts_edit: 'Edit RAP forecasts',
  crt_rap_forecasts_view: 'View RAP forecasts',
  crt_distribution_margin_mix_create: 'Create distribution margin mix',
  crt_distribution_margin_mix_delete: 'Delete distribution margin mix',
  crt_distribution_margin_mix_edit: 'Edit distribution margin mix',
  crt_distribution_margin_mix_view: 'View distribution margin mix',
  crt_distribution_banner_mix_edit: 'Edit distribution banner mix',
  crt_distribution_banner_mix_view: 'View distribution banner mix',
  crt_bpc_actuals_view: 'View BPC actuals',
  crt_bpc_actuals_create: 'Create BPC actuals',
  crt_bpc_actuals_edit: 'Edit BPC actuals',
  crt_bpc_actuals_delete: 'Delete BPC actuals',
  crt_notifications_manage: 'Manage CRT notification subscriptions',
  crt_notifications_view: 'View CRT notifications',
  crt_volume_forecasts_view: 'View volume forecasts',
  crt_volume_forecasts_configure:
    'Configure volume forecasts (NC provincial / channel / sub-channel)',
  crt_volume_scenarios_view: 'View volume scenarios',
  crt_volume_scenarios_create: 'Create volume scenarios',
  crt_volume_scenarios_edit: 'Edit volume scenarios',
  crt_volume_scenarios_delete: 'Delete volume scenarios',
  crt_investments_view: 'View the consolidated investments page',
  crt_manual_investments_create: 'Create manual investments',
  crt_manual_investments_delete: 'Delete manual investments',
  crt_manual_investments_edit: 'Edit manual investments',
  crt_manual_investments_view: 'View manual investments',
  crt_pe_pricing_assumptions_create: 'Create pricing assumptions',
  crt_pe_pricing_assumptions_delete: 'Delete pricing assumptions',
  crt_pe_pricing_assumptions_edit: 'Edit pricing assumptions',
  crt_pe_pricing_assumptions_view: 'View pricing assumptions',
  crt_pe_tax_assumptions_create: 'Create tax assumptions',
  crt_pe_tax_assumptions_delete: 'Delete tax assumptions',
  crt_pe_tax_assumptions_edit: 'Edit tax assumptions',
  crt_pe_tax_assumptions_view: 'View tax assumptions',
  crt_pe_pricing_rate_table_view: 'View pricing rate tables',
  crt_pnl_actuals_view: 'View P&L actuals',
  crt_pnl_forecasts_view: 'View P&L forecasts',
  crt_price_list_snapshots_refresh: 'Refresh a CRT period price list snapshot',
  crt_variance_analysis_view: 'View CRT variance analysis',
  crt_roles_view: 'View CRT roles',
  crt_upload_myUpload_view: 'View my CRT uploads',
  crt_upload_allUploads_view: "View all users' CRT uploads",
  crt_users_manageAccess: 'Manage CRT user access',
  crt_users_view: 'View CRT users',
  sox_compliance_scheduled_reports_create: 'Create SOX compliance scheduled reports',
  sox_compliance_scheduled_reports_delete: 'Delete SOX compliance scheduled reports',
  sox_compliance_scheduled_reports_edit: 'Edit SOX compliance scheduled reports',
  sox_compliance_view: 'View SOX compliance reports',
  customers_banners_view: 'View customer banners',
  customers_stores_view: 'View customer stores',
  invites_delete: 'Delete user invitations',
  invites_send: 'Send user invitations',
  invites_view: 'View user invitations',
  map_viewAllAreas: 'View all geographic areas on map',
  materials_bcp_priced_view: 'View the materials for BCP',
  materials_materials_list_view: 'View the materials list',
  materials_price_list_view: 'View the price list',
  operations_execute: 'Execute operations',
  orders_all_view: 'View all orders',
  orders_charts_view: 'View order charts and analytics',
  orders_editQuantities: 'Edit flagged orders',
  orders_flagged_view: 'View flagged orders',
  orders_leg_release_timeout_edit: 'Edit the order leg auto-release timeout (SHPORD)',
  orders_payment_review_release: 'Change payment terms and release or cancel orders under review',
  orders_payment_review_view: 'View orders held for payment term review',
  orders_release: 'Release orders for processing',
  orders_uncouple: 'Decouple coupled orders',
  orders_returns_view: 'View order returns',
  reports_view: 'View reports',
  reports_view_ecc: 'View ECC reports',
  reports_view_material: 'View material reports',
  reports_view_misc: 'View miscellaneous reports',
  reports_view_operations: 'View operations reports',
  reports_view_order_service: 'View order service reports',
  reports_view_salesforce: 'View Salesforce reports',
  roles_view: 'View roles',
  upload_autoDistro: 'Upload auto distribution data',
  upload_autoInject: 'Upload auto inject data',
  upload_autoInjectDeliveryDates: 'Upload auto inject delivery dates',
  upload_autoInjectRMA: 'Upload auto inject RMA data',
  upload_ediPOConfControl: 'Upload EDI PO confirmation control data',
  upload_onHandInventoryPartial: 'Upload partial on-hand inventory data',
  upload_onHandInventoryUOM: 'Upload on-hand inventory UOM data',
  upload_onHandInventoryDuns: 'Upload on-hand inventory DUNS data',
  upload_materialSpecificationConversion: 'Upload material specification conversion data',
  upload_merchandise: 'Upload merchandise data',
  upload_myUpload_view: 'View my uploads',
  upload_allUploads_view: "View all users' uploads",
  upload_nodAddPosition: 'Upload NOD add position data',
  upload_erpSkuSubstitution: 'Upload ERP SKU substitution data',
  upload_limitQuantity: 'Upload limit quantity data',
  upload_limitQuantityExemptions: 'Upload limit quantity exemptions data',
  upload_routeStopSequence: 'Upload route stop sequence data',
  upload_skuUpcOverride: 'Upload SKU UPC override data',
  upload_suspendOrderSubmission: 'Upload suspend order submission data',
  upload_taxRate: 'Upload tax rate data',
  users_manageAdmins: 'Manage admin users',
  users_managePermissionsOverrides: 'Manage user permission overrides',
  users_manageAccess: 'Manage user access',
  users_manageTerritoriesOverrides: 'Manage user territory overrides',
  users_view: 'View users',
  credit_audit_trails_view: 'View Credit audit trails and activity logs',
  credit_customers_view: 'View Credit customers',
  credit_duns_and_bradstreet_edit: 'Edit customer Dun & Bradstreet numbers',
  credit_index_scores_create: 'Create credit index scores',
  credit_index_scores_delete: 'Delete credit index scores',
  credit_index_scores_update: 'Update credit index scores',
  credit_index_scores_view: 'View credit index scores',
  google_financial_statements_create: 'Create Google financial statements',
  google_financial_statements_delete: 'Delete Google financial statements',
  google_financial_statements_update: 'Update Google financial statements',
  google_financial_statements_view: 'View Google financial statements',
  credit_invites_delete: 'Delete Credit user invitations',
  credit_invites_send: 'Send Credit user invitations',
  credit_invites_view: 'View Credit user invitations',
  credit_delegation_of_authority_view: 'View Credit delegation of authority',
  credit_delegation_of_authority_edit: 'Edit Credit delegation of authority assignments',
  credit_limit_reviews_view: 'View credit limit reviews',
  credit_blocked_orders_view: 'View blocked orders',
  credit_initiatives_view: 'View credit initiatives',
  credit_operations_view: 'View Credit operations',
  credit_multiplier_view: 'View Credit multipliers',
  credit_multiplier_edit: 'Edit Credit multipliers',
  credit_order_cutoff_view: 'View Credit province order cutoffs',
  credit_order_cutoff_edit: 'Edit Credit province order cutoffs',
  credit_province_aov_view: 'View Credit province AOV per carton',
  credit_province_aov_edit: 'Edit Credit province AOV per carton',
  credit_very_low_risk_customers_create: 'Add very low risk customers',
  credit_very_low_risk_customers_delete: 'Delete very low risk customers',
  credit_very_low_risk_customers_view: 'View very low risk customers',
  credit_review_events_view: 'View Credit review events',
  credit_roles_view: 'View Credit roles',
  credit_sap_imports_create: 'Import Credit SAP master data',
  credit_sap_imports_delete: 'Delete Credit SAP master data',
  credit_upload_myUpload_view: 'View my Credit uploads',
  credit_upload_allUploads_view: "View all users' Credit uploads",
  credit_users_manageAccess: 'Manage Credit user access',
  credit_users_view: 'View Credit users',
}

export const PERMISSION_CATEGORIES = {
  assortment: [
    'active_assortment_view',
    'assortment_backups_create',
    'assortment_backups_restore',
    'assortment_banners_edit',
    'assortment_banners_publish',
    'assortment_banners_view',
    'assortment_launches_create',
    'assortment_launches_edit',
    'assortment_launches_publish',
    'assortment_launches_view',
    'assortment_materials_clean_up',
    'assortment_materials_replace',
    'assortment_materials_sequences_edit',
    'assortment_materials_sync',
  ],
  banners: ['customers_banners_view'],
  crt: [
    'crt_async_exports_view',
    'crt_audit_trails_view',
    'crt_azure_imports_view',
    'crt_azure_imports_delete',
    'crt_azure_imports_manage',
    'crt_brand_variants_view',
    'crt_channel_mix_create',
    'crt_channel_mix_delete',
    'crt_channel_mix_edit',
    'crt_channel_mix_view',
    'crt_unreleased_materials_edit',
    'crt_unreleased_materials_view',
    'crt_product_type_variant_create',
    'crt_product_type_variant_view',
    'crt_product_types_edit',
    'crt_product_types_view',
    'crt_material_group_overrides_edit',
    'crt_material_group_overrides_view',
    'crt_agreement_mappings_edit',
    'crt_agreement_mappings_view',
    'crt_agreements_create',
    'crt_agreements_view',
    'crt_sales_deal_actuals_create',
    'crt_sales_deal_actuals_delete',
    'crt_sales_deal_actuals_edit',
    'crt_sales_deal_actuals_export',
    'crt_sales_deal_actuals_view',
    'crt_federal_excise_edit',
    'crt_federal_excise_view',
    'crt_invites_delete',
    'crt_invites_send',
    'crt_invites_view',
    'crt_key_account_contract_estimates_delete',
    'crt_key_account_contract_estimates_edit',
    'crt_key_account_contract_estimates_view',
    'crt_key_accounts_view',
    'crt_materials_materials_list_view',
    'crt_materials_price_list_view',
    'crt_retailer_margins_fmc_edit',
    'crt_retailer_margins_fmc_view',
    'crt_retailer_margins_nc_edit',
    'crt_retailer_margins_nc_view',
    'crt_wholesaler_margins_fmc_edit',
    'crt_wholesaler_margins_fmc_view',
    'crt_wholesaler_margins_nc_edit',
    'crt_wholesaler_margins_nc_view',
    'crt_retailer_rates_edit',
    'crt_retailer_rates_view',
    'crt_consumer_rates_edit',
    'crt_consumer_rates_view',
    'crt_currency_rates_manage',
    'crt_commercial_partners_view',
    'crt_cost_of_goods_create',
    'crt_cost_of_goods_delete',
    'crt_cost_of_goods_edit',
    'crt_cost_of_goods_view',
    'crt_versions_approve',
    'crt_versions_create',
    'crt_versions_delete',
    'crt_versions_edit',
    'crt_versions_view',
    'crt_lmc_targets_edit',
    'crt_lmc_targets_view',
    'crt_budget_allocations_create',
    'crt_budget_allocations_delete',
    'crt_budget_allocations_edit',
    'crt_budget_allocations_view',
    'crt_budget_estimates_edit',
    'crt_budget_tracker_view',
    'crt_calculation_run_accruals_create',
    'crt_calculation_run_accruals_delete',
    'crt_calculation_run_accruals_edit',
    'crt_calculation_run_accruals_view',
    'crt_ip_accruals_create',
    'crt_ip_accruals_delete',
    'crt_ip_accruals_edit',
    'crt_ip_accruals_export',
    'crt_ip_accruals_view',
    'crt_rap_forecasts_create',
    'crt_rap_forecasts_delete',
    'crt_rap_forecasts_edit',
    'crt_rap_forecasts_view',
    'crt_investments_view',
    'crt_manual_investments_create',
    'crt_manual_investments_delete',
    'crt_manual_investments_edit',
    'crt_manual_investments_view',
    'crt_pe_pricing_assumptions_create',
    'crt_pe_pricing_assumptions_delete',
    'crt_pe_pricing_assumptions_edit',
    'crt_pe_pricing_assumptions_view',
    'crt_pe_pricing_rate_table_view',
    'crt_pe_tax_assumptions_create',
    'crt_pe_tax_assumptions_delete',
    'crt_pe_tax_assumptions_view',
    'crt_distribution_margin_mix_create',
    'crt_distribution_margin_mix_delete',
    'crt_distribution_margin_mix_edit',
    'crt_distribution_margin_mix_view',
    'crt_distribution_banner_mix_edit',
    'crt_distribution_banner_mix_view',
    'crt_bpc_actuals_view',
    'crt_bpc_actuals_create',
    'crt_bpc_actuals_edit',
    'crt_bpc_actuals_delete',
    'crt_notifications_manage',
    'crt_notifications_view',
    'crt_pnl_actuals_view',
    'crt_pnl_forecasts_view',
    'crt_price_list_snapshots_refresh',
    'crt_variance_analysis_view',
    'crt_roles_view',
    'crt_upload_myUpload_view',
    'crt_upload_allUploads_view',
    'crt_users_manageAccess',
    'crt_users_view',
    'crt_volume_forecasts_view',
    'crt_volume_forecasts_configure',
  ],
  credit: [
    'credit_audit_trails_view',
    'credit_customers_view',
    'credit_duns_and_bradstreet_edit',
    'credit_index_scores_create',
    'credit_index_scores_delete',
    'credit_index_scores_update',
    'credit_index_scores_view',
    'google_financial_statements_create',
    'google_financial_statements_delete',
    'google_financial_statements_update',
    'google_financial_statements_view',
    'credit_invites_delete',
    'credit_invites_send',
    'credit_invites_view',
    'credit_delegation_of_authority_view',
    'credit_delegation_of_authority_edit',
    'credit_limit_reviews_view',
    'credit_blocked_orders_view',
    'credit_initiatives_view',
    'credit_operations_view',
    'credit_multiplier_view',
    'credit_multiplier_edit',
    'credit_order_cutoff_view',
    'credit_order_cutoff_edit',
    'credit_province_aov_view',
    'credit_province_aov_edit',
    'credit_very_low_risk_customers_create',
    'credit_very_low_risk_customers_delete',
    'credit_very_low_risk_customers_view',
    'credit_review_events_view',
    'credit_roles_view',
    'credit_sap_imports_create',
    'credit_sap_imports_delete',
    'credit_upload_myUpload_view',
    'credit_upload_allUploads_view',
    'credit_users_manageAccess',
    'credit_users_view',
  ],
  compliance: [
    'sox_compliance_scheduled_reports_create',
    'sox_compliance_scheduled_reports_delete',
    'sox_compliance_scheduled_reports_edit',
    'sox_compliance_view',
  ],
  auditTrails: ['audit_trails_view'],
  geography: ['map_viewAllAreas'],
  invitations: ['invites_delete', 'invites_send', 'invites_view'],
  materials: [
    'materials_bcp_priced_view',
    'materials_materials_list_view',
    'materials_price_list_view',
  ],
  operations: ['operations_execute'],
  orders: [
    'orders_editQuantities',
    'orders_release',
    'orders_all_view',
    'orders_flagged_view',
    'orders_returns_view',
    'orders_charts_view',
    'orders_leg_release_timeout_edit',
    'orders_payment_review_view',
    'orders_payment_review_release',
    'orders_uncouple',
  ],
  reports: [
    'reports_view',
    'reports_view_ecc',
    'reports_view_material',
    'reports_view_misc',
    'reports_view_operations',
    'reports_view_order_service',
    'reports_view_salesforce',
  ],
  roles: ['roles_view'],
  stores: ['customers_stores_view'],
  uploadData: [
    'upload_autoDistro',
    'upload_autoInject',
    'upload_autoInjectDeliveryDates',
    'upload_autoInjectRMA',
    'upload_ediPOConfControl',
    'upload_erpSkuSubstitution',
    'upload_limitQuantity',
    'upload_limitQuantityExemptions',
    'upload_materialSpecificationConversion',
    'upload_merchandise',
    'upload_myUpload_view',
    'upload_allUploads_view',
    'upload_nodAddPosition',
    'upload_onHandInventoryDuns',
    'upload_onHandInventoryPartial',
    'upload_onHandInventoryUOM',
    'upload_routeStopSequence',
    'upload_skuUpcOverride',
    'upload_suspendOrderSubmission',
    'upload_taxRate',
  ],
  users: [
    'users_manageAdmins',
    'users_managePermissionsOverrides',
    'users_manageAccess',
    'users_manageTerritoriesOverrides',
    'users_view',
  ],
} as const satisfies Record<string, UserPermission[]>
